import Table from "components/elements/Table";
import dataProvider from "core/DataProvider";
import { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import utility from "core/Utils";
import { ReactComponent as EyeIcon } from "../../../images/eye.svg";
import { useOutletContext } from "react-router-dom";
import GroupMonthlyBillForm from "./GroupMonthlyBill";
//import BillingListing from "./BillingListing";
import BillingMonthReportRequest from "./BillingMonthReportRequest";
import Modal from "components/elements/Modal";
import IconInput from "components/elements/IconInput";
const listingHeaders = {
  action: "Action",
  id: "GID",
  group_name: "Group Name",
  subscription_from: "Subscription From",
  subscription_to: "Subscription To",
  subscription_spots: "Subscribed Spots",
  billed_spots: "Billed Spots",
  final_billed_spots: "Final Billed Spots",
};


const BillingOverviewListing = props => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  //const [showReportPopup, setShowReportPopup] = useState(false);
  // const [selectedClientGroupId, setSelectedClientGroupId] = useState(null);
  //const [renewisPreview, setRenewIsPreview] = useState(false);
  const [clientGroupId, setClentGroupId] = useState("");
  const [headingText, setHeadingText] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const token = useOutletContext();
  const [search, setSearch] = useState("");
  const showReport = (clientGroupId, gname) => {
    setClentGroupId(clientGroupId);
    //setShowReportPopup(true);
    setHeadingText(gname)
    setModalVisible(true);
    //setRenewIsPreview(true);
  };


  const getList = useCallback(async () => {
    setLoading(true);
    try {
      const data = await dataProvider.network.get("billing/overview-list");
      setList(
        data.map(x => ({
          ...x,
          action: (
            <div className="action flex flex-v-center" >
              <div className="action-button flex flex-center" onClick={() => showReport(x.id, x.group_name)}>
                <EyeIcon />
              </div>
            </div>
          ),
          subscription_from: utility.formatDate(x.subscription_from),
          subscription_to: utility.formatDate(x.subscription_to),
        }))
      );
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch billing overview list");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getList();
  }, [getList]);

  return (

    <div className="billing-overview-listing">
      <div className="box mtop">
        <div className="flex flex-v-center">
          <h3 className="pad-lr">Group Overview</h3>
          <div className="right flex">
            <div className="el">

              {loading && (
                <div className="loader">
                  <div className="lds-hourglass"></div>
                </div>
              )}
               <BillingMonthReportRequest />
            </div>
          </div>
        </div>

        <div className="mtop">
           <div className="filter right">
              <div className="flex flex-v-center billing-filter-row">

        <div className="el flex" style={{ alignItems: "first",marginLeft:"15px" }}>
                      <IconInput
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        placeholder="Search (min 3 character)"
                        icon="search"
                        style={{ minWidth: "200px" }}
                      />
                    </div>
                    </div>
                    </div>

          <Table headers={listingHeaders} data={list} search={search} />
        </div>
      </div>

      {modalVisible && (
        <Modal onClose={() => setModalVisible(false)}>
          <GroupMonthlyBillForm
            onClose={() => setModalVisible(false)}
            data={{ grp_heading: headingText, gid: clientGroupId }}
            allowClone={true}
            allowModify={!token.client_type}
          />
        </Modal>
      )}
    </div>


  );
};

export default BillingOverviewListing;
